module.exports = __webpack_public_path__ + "img/普陀.952a7ff4.png";